import { render, staticRenderFns } from "./agencyReviewList.vue?vue&type=template&id=214aeec2&"
import script from "./agencyReviewList.vue?vue&type=script&lang=js&"
export * from "./agencyReviewList.vue?vue&type=script&lang=js&"
import style0 from "./agencyReviewList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports